export const currentArcadeSelector = (state: any) => state.currentArcade;
